import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_OperationTimeDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: string;
    value?: number;
    position: e_Positions;
};

export enum e_Positions {
    Connection_Upper_Undercarriage,
    Undercarriage, // Fahren
    Main_Uppercarriage, //Machine
    Equipment, //Werkzeug
    Hydraulic,
}

export type t_OperationTimeDataset = {
    dataPoints: t_OperationTimeDataPoint[];
};

export var initOperationTimeDataset: t_OperationTimeDataset = {
    dataPoints: [
        {
            generalName: 'DATANAMES.TIMES.MACHINE',
            dataName: {
                name: 'MachineOperatingTime',
            },
            unit: 'h',
            position: e_Positions.Main_Uppercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.T15',
            dataName: {
                name: 'MachineT15Time',
            },
            unit: 'h',
            position: e_Positions.Main_Uppercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.ENGINE_RUNNING',
            dataName: {
                name: 'MachineEngineRunningTime',
            },
            unit: 'h',
            position: e_Positions.Main_Uppercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.BOOM',
            dataName: {
                name: 'OperatingTimeBoom',
            },
            unit: 'h',
            position: e_Positions.Equipment
        },
        {
            generalName: 'DATANAMES.TIMES.DRIVE',
            dataName: {
                name: 'OperatingTimeDrive',
            },
            unit: 'h',
            position: e_Positions.Undercarriage
        },
        {
            generalName: 'DATANAMES.TIMES.TELE',
            dataName: {
                name: 'OperatingTimeTele',
            },
            unit: 'h',
            position: e_Positions.Equipment
        },
        {
            generalName: 'DATANAMES.TIMES.FORK',
            dataName: {
                name: 'OperatingTimeFork',
            },
            unit: 'h',
            position: e_Positions.Equipment
        },
        {
            generalName: 'DATANAMES.TIMES.SHS13',
            dataName: {
                name: 'OperatingTimeSHS13',
            },
            unit: 'h',
            position: e_Positions.Hydraulic
        },
        
        {
            generalName: 'DATANAMES.TIMES.SHS2',
            dataName: {
                name: 'OperatingTimeSHS2',
            },
            unit: 'h',
            position: e_Positions.Hydraulic
        },
    ],
};
